// @flow
import actionCreators from "@modules/reporting/actionCreator";
import type { Action } from "redux-action";
import { all, call, put, takeEvery, select } from "redux-saga/effects";
import http from "@http";
import config from "@config";
import { GetMyNotifications } from "@modules/reporting/constants/actions";
import type { MyNotifications } from "@modules/reporting/reducer/notifications/types";
import { getMyNotificationsPage } from "@modules/reporting/selectors/notifications";
import { transformFilters, OPERATORS } from "@transformers/request";

type GetMyNotificationsRequest = $Exact<{
  clientId: string,
  page?: number,
  search?: $Exact<{
    employee?: string,
  }>,
}>;

export function* onGetMyNotifications({
  payload,
}: Action<GetMyNotificationsRequest>): Generator<*, void, { data: Array<MyNotifications> }> {
  if (!payload || !payload.clientId) {
    throw Error("Invalid payload provided");
  }
  try {
    let { page } = payload;
    if (!page) {
      page = yield select(getMyNotificationsPage);
    }

    const response = yield call(
      http.get,
      `/api/v1/tools/client/${payload.clientId}/tools/dashboard/my-notifications`,
      {
        params: {
          page,
          search: transformFilters(payload.search || {}, { employee: OPERATORS.LIKE }),
          limit: config.shortResultsPerPage,
          sort: "id,desc",
        },
      },
    );

    yield put(actionCreators.GetMyNotificationsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetMyNotificationsError(e.response));
  }
}

export function* MyNotificationsSaga(): Generator<*, void, void> {
  yield all([takeEvery(GetMyNotifications, onGetMyNotifications)]);
}

export default MyNotificationsSaga;
